export { GalaxyStyleModule } from './src/style.module';
export { GalaxyTheme, StyleService } from './src/style.service';
export { preferredTheme, isDarkTheme, isV2Theme, COLOR_SCHEME_ATTRIBUTE } from './src/style.service';
